import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./api/api";
import { initializeInterceptors } from "./api/initInterceptors";
import App from "./App.tsx";
import i18n from "./i18n.ts";
import "./index.css";
initializeInterceptors(); // Intercepteurs init AVANT que l’app ne démarre

if (import.meta.env.VITE_MEMOIRS_APP_ENV !== "development") {
  Sentry.init({
    dsn: import.meta.env.VITE_MEMOIRS_SENTRY_DSN,
    environment: import.meta.env.VITE_MEMOIRS_APP_ENV,
  });
  Sentry.setTag("memoirs_version", import.meta.env.VITE_MEMOIRS_VERSION);
}

i18n.init().then(() => {
  // Only render your app after i18next is ready
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
